import TempleDetailsView from "../../Views/Temple/TempleDetailsView";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getTempleDetailsById,
  getTempleDetailsByNameKey,
} from "../../store/actions/templeAction";
import { getOneImageForTemple } from "../../utils/HelperFunctions";
import ParentView from "../../Views/PrarentView/ParentView";
import HelmetComponent from "../../components/Shared/HelmetComponent";
import { LOCALSTORAGE_KEY, metaTempleImg } from "../../utils/Constants";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
function TempleDetailsScreen(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const { selectedTempleDetails } = useSelector((state: any) => state.temple);

  const templePersonalInfo =
    selectedTempleDetails && selectedTempleDetails.personalInfo
      ? selectedTempleDetails.personalInfo
      : {};

  const templeProfilePic = () => {
    let imageArrayForTemple =
      templePersonalInfo &&
      templePersonalInfo.media &&
      templePersonalInfo.media.pictures &&
      templePersonalInfo.media.pictures.length
        ? templePersonalInfo.media.pictures
        : [];
    let templeProfilePic = getOneImageForTemple(imageArrayForTemple);
    return templeProfilePic;
  };
  const goToBookPujaScreen = () => {
    navigate("/templePujas?templeNameKey=" + selectedTempleDetails?.nameKey);
  };
  const goToBookChadhavaScreen = () => {
    navigate("/chadhavaDetails/" + selectedTempleDetails?.nameKey);
  };
  const goToBookPrasadScreen = () => {
    navigate("/prasadDetails/" + selectedTempleDetails?.nameKey);
  };

  useEffect(() => {
    let keyType = props?.keyType;
    if (keyType && keyType === "id") {
      const templeIdComing = location.pathname.split("/")[2];
      dispatch(getTempleDetailsById(templeIdComing))
        .then((res: any) => {
          if (typeof res === "undefined") {
            navigate("/temples");
          }
        })
        .catch((err: any) => {
          console.log("Error:", err);
          navigate("/temples");
        });
    } else {
      const params = new URLSearchParams(location.search);
      const templeId = params.get("templeNameKey");
      const templeIdComing = templeId;
      dispatch(getTempleDetailsByNameKey(templeIdComing))
        .then((res: any) => {
          if (typeof res === "undefined") {
            navigate("/temples");
          }
        })
        .catch((err: any) => {
          console.log("Error:", err);
          navigate("/temples");
        });
    }
  }, []);

  useEffect(() => {
    if (!selectedTempleDetails?.id) return;
    dispatch(
      pageReady({
        User_ID:
          JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
            ?.id ?? "Guest User",
        Temple_ID: selectedTempleDetails?.id ?? "",
        Temple_Name: selectedTempleDetails?.personalInfo?.name ?? "",
        Temple_NameKey: selectedTempleDetails?.nameKey ?? "",
        Page_Type: "Temple Details",
        Device_Type: getDeviceTypeFromUserAgent(),
        City: selectedTempleDetails?.personalInfo?.address?.city ?? "",
        State: selectedTempleDetails?.personalInfo?.address?.state ?? "",
        Diety: selectedTempleDetails?.personalInfo?.primaryGodName ?? "",
      }),
    );
  }, [selectedTempleDetails?.id]);

  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;
  const templInfoPath = location.pathname;

  return (
    <ParentView>
      <HelmetComponent
        metaData={{
          title:
            selectedTempleDetails?.templeMetaData?.metaTitle ??
            selectedTempleDetails?.personalInfo?.name ??
            "Temple" + " | TempleDekho",
          keywords: selectedTempleDetails?.templeMetaData?.metaKeys ?? null,
          robots: "index, follow",
          description:
            selectedTempleDetails?.templeMetaData?.metaDescription ??
            selectedTempleDetails?.personalInfo?.descriptions,
          url: hostname + templInfoPath,
          imageUrl: selectedTempleDetails?.personalInfo?.media?.pictures?.length
            ? selectedTempleDetails?.personalInfo?.media?.pictures[0]
                ?.pictureUrl
            : metaTempleImg,
        }}
      >
        <TempleDetailsView
          templeDetails={selectedTempleDetails}
          templePersonalInfo={templePersonalInfo}
          goToBookPujaScreen={goToBookPujaScreen}
          goToBookChadhavaScreen={goToBookChadhavaScreen}
          goToBookPrasadScreen={goToBookPrasadScreen}
          templeProfilePic={templeProfilePic}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default TempleDetailsScreen;
